exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td[data-v-886a00e8],.table th[data-v-886a00e8]{vertical-align:middle}", ""]);

// exports
